import * as React from "react";
import { FunctionField, TextInput, TextField, EditButton } from "react-admin";
import { Datagrid, IfCanAccess, List } from "src/enterprise/ra-rbac";

const listFilters = [<TextInput source="search" label="Search" alwaysOn />];

export const AttributeSetList = (props) => {
  return (
    <List {...props} filters={listFilters} queryOptions={{ cacheTime: 0 }}>
      <Datagrid>
        <TextField source="id" />
        <TextField source="name" />
        <FunctionField
          label="Attributes Count"
          render={(record) =>
            record.attributes ? record.attributes?.length : 0
          }
        />
        <IfCanAccess action="edit">
          <EditButton />
        </IfCanAccess>
      </Datagrid>
    </List>
  );
};
